import React, { createContext, useContext, FC } from 'react';
import { WorkPackage } from '@bechtel/types';

const WorkPackageContextPrivate = createContext<WorkPackageContextProps>({ id: '', tag: '' });

const { Provider } = WorkPackageContextPrivate;

export const useWorkPackage = () => {
  return useContext(WorkPackageContextPrivate);
};

interface WorkPackageContextProps {
  id: WorkPackage['id'];
  tag: WorkPackage['tag'];
  startDate?: WorkPackage['startDate'];
  endDate?: WorkPackage['endDate'];
  assignedCrewMembers?: WorkPackage['primaryOwners'];
  facilities?: WorkPackage['facilities'];
}

export const WorkPackageContext: FC<WorkPackageContextProps> = ({ children, ...workPackageProps }) => {
  return <Provider value={workPackageProps}>{children}</Provider>;
};
